import classNames from 'classnames';
import React, { FC } from 'react';

const WrapWithButtonBlur: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showChart, setShowChart] = React.useState(false);

  const combinedClassName = classNames('button-blur-wrapper', {
    unblurred: showChart,
    blurred: !showChart,
  });

  return (
    <div className={combinedClassName}>
      <div className="button-blur-overlay">
        {!showChart && (
          <div className="disclaimer-box">
            <header className="header">
              <i className="fa-solid fa-circle-info" />
              <span>Backtesting: Please Note</span>
            </header>
            <main className="content">
              <div className="d-flex">
                <i className="fa-regular fa-chart-line-up" />
                <span>
                  Backtesting is based on historical market data and assumes ideal trading conditions.
                </span>
              </div>
              <div className="d-flex">
                <i className="fa-regular fa-arrow-up-arrow-down" />
                <span>These results do not reflect actual trades or live market execution.</span>
              </div>
              <div className="d-flex">
                <i className="fa-regular fa-clock" />
                <span>Past performance is not indicative of future returns.</span>
              </div>
            </main>
            <footer className="btn btn-primary" onClick={() => setShowChart(true)}>
              I understand, Backtest now.
            </footer>
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default WrapWithButtonBlur;
